<kommentar-traader [forelder]="sakId()"/>
<ny-kommentar-traad [gruppeId]="gruppeId()" (vedFulltSkjemaAktivert)="nyTraadFullSkjemaAktivert($event)"/>
